import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import { fetchPointsBalance } from "@/modules/account/thunks/fetchPointsBalance";
import store from "@/store";

export const actions = {
  /**
   * Refreshes the points balance after booking confirmation.
   *
   * We dispatch the Redux thunk from this XState entry action because:
   * - The thunk fetches the updated balance from the API after a booking completes
   * - The PointsBanner (and any component using the balance) re-renders with the new value
   * - The user can see their updated points balance on the confirmation screen after booking
   * - Notifies the native app to update points display (fires onFeatureEvent)
   */
  refreshPointsBalance: () => {
    store.dispatch(fetchPointsBalance({ notifyNativeApp: true }));
  },
};

export const ActionTypes = getObjectKeysAsObject(actions);
